import React from "react";

const Control = ({ height, style }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 100 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2181_23028)">
      <rect
        x="3"
        y="0.589355"
        width="96.1481"
        height="59"
        rx="7.18683"
        fill="#EFF1F5"
      />
      <rect
        x="3.62885"
        y="1.2182"
        width="94.8904"
        height="57.7423"
        rx="6.55798"
        stroke="#212326"
        strokeWidth="1.2577"
      />
    </g>
    <path
      d="M25.7981 32.2689C24.7885 32.2689 23.9217 32.0904 23.1977 31.7335C22.4737 31.3766 21.8822 30.9126 21.4233 30.3416C20.9746 29.7705 20.6432 29.1485 20.4291 28.4754C20.2149 27.8024 20.1078 27.1548 20.1078 26.5328V26.1963C20.1078 25.5028 20.2149 24.8196 20.4291 24.1466C20.6534 23.4735 20.995 22.8617 21.4539 22.311C21.9128 21.7603 22.4941 21.3219 23.1977 20.9955C23.9115 20.659 24.7528 20.4908 25.7216 20.4908C26.7311 20.4908 27.6081 20.6743 28.3525 21.0414C29.1072 21.3983 29.7088 21.9082 30.1575 22.571C30.6062 23.2237 30.8764 23.9885 30.9682 24.8655H28.7808C28.6993 24.3556 28.5157 23.9273 28.2302 23.5806C27.9548 23.2237 27.603 22.9586 27.1747 22.7852C26.7464 22.6016 26.2621 22.5099 25.7216 22.5099C25.1709 22.5099 24.6814 22.6067 24.2531 22.8005C23.8248 22.984 23.4679 23.2492 23.1824 23.5959C22.8969 23.9426 22.6776 24.3505 22.5247 24.8196C22.3819 25.2887 22.3105 25.8088 22.3105 26.3798C22.3105 26.9305 22.3819 27.4404 22.5247 27.9095C22.6776 28.3785 22.902 28.7915 23.1977 29.1485C23.4934 29.4952 23.8554 29.7654 24.2837 29.9592C24.7222 30.1529 25.227 30.2498 25.7981 30.2498C26.6343 30.2498 27.3379 30.0458 27.909 29.6379C28.4902 29.2198 28.842 28.6386 28.9644 27.8942H31.1518C31.0498 28.6896 30.7796 29.4187 30.3411 30.0815C29.9026 30.7444 29.3009 31.2746 28.5361 31.6723C27.7713 32.07 26.8586 32.2689 25.7981 32.2689ZM36.6355 32.0853C35.8707 32.0853 35.2384 31.9885 34.7387 31.7947C34.2493 31.5908 33.8822 31.2542 33.6374 30.7852C33.3927 30.3059 33.2703 29.6634 33.2703 28.8578L33.2856 21.332H35.2741L35.2588 28.9955C35.2588 29.4034 35.3659 29.7195 35.58 29.9439C35.8044 30.158 36.1205 30.2651 36.5284 30.2651H37.8286V32.0853H36.6355ZM31.9548 25.2326V23.6724H37.8286V25.2326H31.9548ZM39.6131 31.9783V23.6724H41.2957V27.1905H41.2498C41.2498 25.9974 41.5048 25.0949 42.0146 24.4831C42.5245 23.8712 43.274 23.5653 44.2632 23.5653H44.5691V25.4162H43.9879C43.274 25.4162 42.7183 25.6099 42.3206 25.9974C41.9331 26.3747 41.7393 26.9254 41.7393 27.6494V31.9783H39.6131ZM46.0986 31.9783V20.812H48.2248V31.9783H46.0986ZM45.0585 22.4028V20.812H48.2248V22.4028H45.0585Z"
      fill="#42464C"
    />
    <defs>
      <filter
        id="filter0_d_2181_23028"
        x="0.88037"
        y="0.589355"
        width="98.2678"
        height="63.3704"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.11963" dy="4.37037" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.27451 0 0 0 0 0.298039 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2181_23028"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2181_23028"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default Control;
